<template>
  <div>
    <div
      v-for="(value, index) in bejegyzesIcons"
      :key="index"
      class="d-block text-center"
    >
      <b-img
        v-if="
          getIkonByNev(value).includes('.png') ||
            getIkonByNev(value).includes('.svg')
        "
        :src="require('../../assets/images/' + getIkonByNev(value))"
        alt="Responsive image"
        class="icon-img"
      ></b-img>
      <k-icon v-else :name="getIkonByNev(value)" fontSize="18"> </k-icon>
      <span class="d-block" v-if="iconText == true">{{ $t(value) }}</span>
    </div>
  </div>
</template>

<script>
import { getIkonByNev } from '../../data/ikonok';

export default {
  name: 'bejegyzes-ikonok',
  data() {
    return {};
  },
  mounted() {},
  created() {},
  methods: {
    getIkonByNev(nev) {
      return getIkonByNev(nev);
    },
  },
  computed: {},
  watch: {},
  props: {
    bejegyzesIcons: {
      type: Array,
      required: true,
    },
    iconText: {
      type: Boolean,
    },
  },
};
</script>
<style scoped>
i {
  color: #2f3b59 !important;
}
span {
  font-weight: 500;
}

div {
  text-align: left;
}

.card-listing .listing-item:not(.list-layout) div {
  text-align: center;
}
.listing-item .geodir-category-content .ikonok div,
.map-popup .ikonok div div {
  margin-right: 0.25rem !important;
  margin-bottom: 1rem !important;
  width: 80px;
  line-height: 1.5;
}
.map-popup .ikonok span {
  font-size: 12px !important;
}
@media (min-width: 576px) {
  .listing-item .geodir-category-content .ikonok div {
    margin-right: 1rem !important;
  }
}
.card-listing .list-post-counter i {
  color: #fff !important;
  padding-left: 0px;
}
</style>
